<ng-container *ngIf="(tableMetaWithDataKey$ | async) as tableMeta; else loadingView">
  <ng-container *ngIf="(tableData$ | async) as tableData; else loadingView">
    <ng-container *ngIf="showInOverlay; else widget">
      <p-button (click)="togglePanel($event)" icon="pi pi-plus-circle" #overlayButton></p-button>
      <i class="pi pi-tag ml-3 text-5xl info-badge" pBadge [value]="$any(tableData.totalRecords)" severity="info" *ngIf="tableData.totalRecords"></i>
      <p-overlayPanel #overlayPanel>
        <ng-container *ngTemplateOutlet="widget"></ng-container>
      </p-overlayPanel>
    </ng-container>
    <ng-template #widget>
      <ng-container *ngIf="!readOnly">
      <ng-container *ngIf="tableMeta.viewName !== 'en_jedinica_gradiva_autor' && tableMeta.viewName !== 'en_jedinica_gradiva_mjesto' && tableMeta.viewName !== 'seup_pismeno_osoba_id' && tableMeta.viewName !== 'en_jedinica_gradiva_primatelj' && tableMeta.viewName !== 'en_jedinica_gradiva_posiljatelj' && tableMeta.viewName !== 'seup_posiljka_posiljatelj' && tableMeta.viewName !== 'seup_posiljka_primatelj' ">
        <button pButton pRipple type="button" icon="pi pi-plus" (click)="onAddNewItem(tableMeta)"
        class="p-button-rounded p-button-text"></button>
      </ng-container>
          <app-editable-table-additional-actions class="flex gap-1" [editableTableActions]="tableMeta.actions"></app-editable-table-additional-actions>
      </ng-container>
      <p-table #dataTable preventSelectionSetterPropagation="false" [value]="tableData.items"
        [columns]="tableMeta.columns" [selection]="selectedItems$ | async" (selectionChange)="setSelectedItems($event)"
        [paginator]="tableMeta.pagingSetup.lazy ? tableData.totalRecords >= 15 : true" responsiveLayout="stack"
        [loading]="(loadingState$ | async) ?? true" [lazy]="tableMeta.pagingSetup.lazy"
        [totalRecords]="tableData.totalRecords" (onPage)="tableMeta.pagingSetup.pageHandler($event, tableData)"
        (sortFunction)="handleSort($event)" [customSort]="true" [filters]="tableData.filters" [rows]="tableData.rows"
        [first]="dataTable.first" editMode="row" [dataKey]="tableMeta.dataKey" styleClass="p-datatable-sm"
        [alwaysShowPaginator]="false"
        class="w-full">
  
        <ng-template pTemplate="header" let-columns>
          <ng-container *ngIf="tableData.totalRecords > 0 && columns.length > 1">
            <tr>
              <th *ngFor="let column of tableMeta.columns"
              [ngClass]="{ 'd-none': column.name === 'rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id' || column.name === 'sv~autor~identifikator' || column.name === 'sv~mjesto~mjesto_id'
              }" [pSortableColumn]="column.name">
                {{column.description}}
                <p-sortIcon *ngIf="column.name === 'en~agent~naziv' || column.name === 'sv~autor~vrsta_autorstva_id'"
                  [field]="column.name"></p-sortIcon>
              </th>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="body" ngFor let-item let-editing="editing" let-rowIndex="rowIndex">
          <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
            *ngIf="tableData.tableItems[tableMeta.pagingSetup.rowIndexFunction(tableData.firstIndex, rowIndex)] as tableItem">
            <tr [pEditableRow]="item" app-editable-table-row [item]="item" [readOnly]="readOnly" [tableMeta]="tableMeta"
              [tableData]="tableData" [tableItem]="tableItem" [editing]="editing" [rowIndex]="rowIndex"
              [parentItem]="parentItem | async" relToParentItemKey="entitet_id">
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </ng-template>
  </ng-container>
</ng-container>
<ng-template #loadingView>
  <p-progressSpinner></p-progressSpinner>
</ng-template>